import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { okaidia, vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useTheme } from '../../common/hooks/use-theme';

interface CodeBlockProps {
  children: string;
  language?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({
  children,
  language = 'python'
}) => {
  const { isDark } = useTheme();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(children).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="relative my-[16px]">
      <button
        onClick={handleCopy}
        title="Copy code"
        className={`absolute top-[8px] right-[8px] z-[1] border border-white/15 rounded-[5px] px-[8px] py-[3px] cursor-pointer text-[11px] font-body transition-[background,color] duration-150
          ${copied ? 'bg-green-600 text-white' : 'bg-content-muted-alt text-surface-card'}`}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
      <SyntaxHighlighter
        language={language}
        style={isDark ? okaidia : vscDarkPlus}
        customStyle={{
          borderRadius: '8px',
          fontSize: '12px',
          margin: 0,
          lineHeight: 1.65
        }}
      >
        {children}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeBlock;
